export const FeatureName = {
  ASYNC_AUTO_ASSIGNMENT: 'ASYNC_AUTO_ASSIGNMENT',
  ASYNC_BATCH_ACTIONS: 'ASYNC_BATCH_ACTIONS',
  /**
   * Gates audio recording item properties (Helsing SOW): the "Audio" option
   * in item-property creation and the recorder UI. Mirrors the backend
   * per-team flag of the same name. Existing audio values render regardless.
   */
  AUDIO_ANNOTATION: 'AUDIO_ANNOTATION',
  AUTO_LABEL: 'AUTO_LABEL',
  CONSENSUS_STAGE_V2_ALL_TOOLS_ENABLED: 'CONSENSUS_STAGE_V2_ALL_TOOLS_ENABLED',
  EYE_TOOL: 'EYE_TOOL',
  IMAGE_TAG_LOADER: 'IMAGE_TAG_LOADER',
  LEGACY_DICOM: 'LEGACY_DICOM',
  DYNAMIC_MPR: 'DYNAMIC_MPR',
  SHOW_NON_DEFAULT_V1_TEMPLATE_FF: 'SHOW_NON_DEFAULT_V1_TEMPLATE_FF',
  SIMPLE_TABLE: 'SIMPLE_TABLE',
  TEST_FEATURE: 'TEST_FEATURE',
  TEST_FEATURE_2: 'TEST_FEATURE_2',
  WORKSPACE_PRICING: 'WORKSPACE_PRICING',
  _AUTOLABEL_SUPERADMIN: '_AUTOLABEL_SUPERADMIN',
  /**
   * Used to show settings for Auto-Track on the Dataset Settings page.
   */
  AUTOTRACK_OBB_OUTPUT: 'AUTOTRACK_OBB_OUTPUT',
  AUTOTRACK_SKIP_FRAMES: 'AUTOTRACK_SKIP_FRAMES',
  /**
   * @deprecated
   * In use for e2e tests only.
   */
  LONG_VIDEOS: 'LONG_VIDEOS',
  /**
   * @deprecated Technically retired from frontend, but an E2E suite still needs it.
   * Do not use in other cases.
   */
  SENTRY_REPLAY: 'SENTRY_REPLAY',
  FRAMES_MANIFEST_WITH_FRAMES_EXTRACTION: 'FRAMES_MANIFEST_WITH_FRAMES_EXTRACTION',
  ANNOTATIONS_PACKAGE: 'ANNOTATIONS_PACKAGE',
  ENABLE_DEV_CONFIGS: 'ENABLE_DEV_CONFIGS',
  ANNOTATIONS_PAGINATION: 'ANNOTATIONS_PAGINATION',
  PARALLEL_BLIND_STAGE: 'PARALLEL_BLIND_STAGE',
  AUDIO_WAVE: 'AUDIO_WAVE',
  DISABLE_TEXT_ATTRIBUTES: 'DISABLE_TEXT_ATTRIBUTES',
  WEB_GL_MASK_RENDERING: 'WEB_GL_MASK_RENDERING',
  QUALITY_REPORT_V2: 'QUALITY_REPORT_V2',
  BRUSH_WORKER: 'BRUSH_WORKER',
  SAM_FOR_TILED_IMAGES: 'SAM_FOR_TILED_IMAGES',
  DATASET_FILTER_V2: 'DATASET_FILTER_V2',
  POINT_BY_POINT_SKELETON: 'POINT_BY_POINT_SKELETON',
  MASK_INTERPOLATION: 'MASK_INTERPOLATION',
  KEYPOINT_3D_TOOL: 'KEYPOINT_3D_TOOL',
  AI_REVIEW_FEEDBACK: 'AI_REVIEW_FEEDBACK',
  DISABLE_UNPROCESSED_VIDEO_REGISTRATION: 'DISABLE_UNPROCESSED_VIDEO_REGISTRATION',
  CLASS_PROPERTIES_IN_LOGIC_STAGE: 'CLASS_PROPERTIES_IN_LOGIC_STAGE',
  /**
   * Gates the V2 consensus pipeline running on single-select item-level
   * properties: per-property threshold configuration, the disagreement badge
   * surfaced in the workview item-property sidebar, and the dedicated
   * conflict-resolution panel rendered in the Review tab. Mirrors the
   * backend per-team flag of the same name.
   */
  CONSENSUS_ON_ITEM_PROPERTIES: 'CONSENSUS_ON_ITEM_PROPERTIES',
  /**
   * Gates the User Tags feature: tagging team members and using tags as a
   * quick-pick filter when configuring workflow stage assignees. Mirrors the
   * backend per-team flag of the same name. When off, the chip editor on
   * each member row, the Manage tags modal, and the workflow picker tag
   * strip are all hidden.
   */
  USER_TAGS: 'USER_TAGS',
} as const

export type FeatureName = (typeof FeatureName)[keyof typeof FeatureName]

export type FeaturePayload = {
  enabled: boolean
  // removing feature from here will reveal its usage across the codebase
  // TEST_FEATURE and TEST_FEATURE_2 exist purely for test support
  name: FeatureName
}
